import { embedQuizType } from './commonFunctions';
import { EVENT_TRACKING_KEY, TRACKING_ELEMENT_ID } from './constants';

export const gaEventTracking = (event) => {
  if (!event) return;

  const { category, label, eventLabel } = event || {};

  const common = {
    event: 'siGamingEvent'
  };

  let trackingObj = {
    ...common,
    si_gaming: {
      // event_name: 'quiz_game',
      event_name: `${embedQuizType()?.toLowerCase() ?? "daily"}_quiz`,
      event_parameter: category,
      event_value: label
    }
  };

  if (eventLabel) {
    trackingObj.si_gaming['label'] = eventLabel;
  }

  try {
    window.dataLayer = window.dataLayer || [];
    if (category && label) {
      window.dataLayer.push(trackingObj);
    }
  } catch (error) {
    console.error(error);
  }
};

export const eventTrackingHandler = (e) => {
  const ancestorElement = e.target.closest('#' + TRACKING_ELEMENT_ID);
  const hasTrackingAttribute = ancestorElement?.getAttribute(EVENT_TRACKING_KEY);

  if (hasTrackingAttribute) {
    let trackingConstant;

    try {
      trackingConstant = JSON.parse(hasTrackingAttribute);
    } catch (error) {
      trackingConstant = hasTrackingAttribute;
    }
    if (trackingConstant) {
      gaEventTracking(trackingConstant);
    }
  }
};

export const trackingConstant = {
  HOME_TAB_CLICKED: {
    category: 'home_screen_button-clicked',
    label: 'Home Tab Clicked'
  },
  LEADERBOARD_TAB_CLICKED: {
    category: 'leaderboard_screen_button-clicked',
    label: 'Leaderboard Tab Clicked'
  },
  RULES_TAB_CLICKED: {
    category: 'rules_screen_button-clicked',
    label: 'Rules Tab Clicked'
  },
  PRIZES_TAB_CLICKED: {
    category: 'prizes_screen_button-clicked',
    label: 'Prizes Tab Clicked'
  },
  PLAY_NOW_BUTTON_CLICKED: {
    category: 'play_now_button-clicked',
    label: 'Play Now Button Clicked'
  },
  PLAY_AGAIN_BUTTON_CLICKED: {
    category: 'play_again_button-clicked',
    label: 'Play Again Button Clicked'
  },
  PLAY_AS_A_GUEST_BUTTON_CLICKED: {
    category: 'play_as_a_guest_button-clicked',
    label: 'Play As A Guest Button Clicked'
  },
  VIEW_LEADERBOARD_BUTTON_CLICKED: {
    category: 'view_leaderboard_button-clicked',
    label: 'View Leaderboard Button Clicked'
  },
  BACK_TO_HOME_FROM_QUIZ: {
    category: 'back_to_home_button_clicked',
    label: 'Back to Home Button Clicked while playing a quiz'
  },
  BACK_TO_HOME_FROM_RESULT: {
    category: 'back_to_home_button_clicked',
    label: 'Back to Home Button Clicked on the result page'
  },
  QUESTION: {
    category: 'question{questionNumber}_attempted',
    label: '{questionNumberWithSuffix} Question Attempted'
  },
  SOCIAL_SHARING_BUTTON_CLICKED: {
    category: 'social_sharing_button-clicked',
    label: 'Social Sharing Button Clicked'
  },
  EMAIL_ID_SUBMITTED: {
    category: 'email_id_submitted',
    label: 'Email ID successfully submitted'
  },
  THIRD_UMPIRE_BOOSTER_USED: {
    category: 'thirdumpire_lifeline_used',
    label: 'Third Umpire Lifeline Used',
    eventLabel: 'Booster used for question {questionNo}'
  },
  FIFTY_FIFTY_BOOSTER_USED: {
    category: '50_50_lifeline_used',
    label: '50-50 Lifeline Used',
    eventLabel: 'Booster used for question {questionNo}'
  },
  EXIT_POPUP_LEAVE_BUTTON_CLICKED: {
    category: 'exit_game_popup',
    label: 'leave_button_clicked'
  },
  EXIT_POPUP_CONTINUE_BUTTON_CLICKED: {
    category: 'exit_game_popup',
    label: 'continue_button_clicked'
  },
  HOME_AD_BANNER_CLICKED: {
    category: 'ad_banner_clicked',
    label: 'Ad Banner on Homepage clicked'
  },
  GAME_AD_BANNER_CLICKED: {
    category: 'ad_banner_clicked',
    label: 'Ad Banner on Gameplay clicked'
  },
  RESULT_SCREEN_LOADED: {
    category: 'result_page_loaded',
    label: 'Result Page loaded'
  },
  RULES_SCREEN_LOADED: {
    category: 'rules_screen_loaded',
    label: 'Rules Page loaded'
  },
  HOME_SCREEN_LOADED: {
    category: 'home_screen_loaded',
    label: 'Home Page loaded'
  }
};
